import React from "react";
import useApi from "../../hooks/useApi";
import ClienteApiClient from "../../api/cliente";
import { AppContext } from "../../contexts/AppContext";
import { useParams, useLocation } from "react-router-dom";
import Card from "../../components/page/Card";
import TabContent from "../../components/Tab/TabContent";
import StepsButton from "../../components/steps/StepsButton";
import StepsList from "../../components/steps/StepsList";
import ClienteDadosCPF from "./Cliente/ClienteDadosCPF";
import ClienteDadosEx from "./Cliente/ClienteDadosEx";
import ClienteEndereco from "./Cliente/ClienteEndereco";
import ClienteDadosCNPJ from "./Cliente/ClienteDadosCNPJ";
import ClienteButtons from "./Cliente/ClienteButtons";
import Validation from "../../helpers/Validation";
import CommonSwal from "../../components/Swal/commonSwal";
import ErrorSwal from "../../components/Swal/errorSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import ReceitaApiClient from "../../api/receita";
import { Cores } from "../../constants/Cores";
import LocalidadeApiClient from "../../api/localidade";
import TabPane from "../../components/Tab/TabPane";

function Cliente() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cnpj = queryParams.get("cnpj");

  const { uid } = useParams();

  const [values, setValues] = React.useState({});
  const { session, baseUrl } = React.useContext(AppContext);

  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const { request: getCliente, data: clienteResponse } = useApi(
    ClienteApiClient.getCliente
  );
  const putClienteApi = useApi(ClienteApiClient.putCliente);
  const postClienteApi = useApi(ClienteApiClient.postCliente);
  const getCnpjApi = useApi(ReceitaApiClient.getCnpj);

  //Busca cliente ao renderizar tela
  React.useEffect(() => {
    if (!session.empresa || !uid || cnpj) return;
    getCliente(session.empresa.replace(/E/gi, ""), uid);
  }, [cnpj, getCliente, session.empresa, uid]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (!clienteResponse) return;
    setValues(clienteResponse);
  }, [clienteResponse]);

  //Define cnpj no estado caso exista
  React.useEffect(() => {
    if (!cnpj) return;
    setValues({ cnpj, uid });
  }, [cnpj, uid]);

  const salvaCliente = async () => {
    OptionsSwal({
      title: "Deseja realmente salvar os dados do cliente?",
      icon: "warning",
      confirmButtonColor: Cores.buttons.azulConfirm,
      denyButtonColor: Cores.buttons.cinzaDeny,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { erros, formData } = validaCliente();

        if (erros)
          return ErrorSwal({
            text: "Favor preencher todos os dados obrigatórios.",
          });

        var response;
        cnpj
          ? (response = postClienteApi.request(
              session.empresa.replace(/E/gi, ""),
              formData
            ))
          : (response = putClienteApi.request(
              session.empresa.replace(/E/gi, ""),
              uid,
              formData
            ));
        if (!response) return;
        CommonSwal({
          icon: "success",
          title: "Dados do cliente salvos com sucesso!",
        }).then(() => {
          window.location.href = baseUrl + "cliente/Cliente";
        });
      }
    });
  };

  const validaCliente = () => {
    const formData = new FormData();
    var erros;

    if (values.cnpj === "99999999999") {
      formData.append("uid", values?.uid || "");
      formData.append("razao_social", values?.razao_social || "");
      formData.append("logradouro", values?.logradouro || "");
      formData.append("numero", String(values?.numero) || "");
      formData.append("cidade", values?.cidade || "");
      formData.append("uf", values?.uf || "");
      formData.append("cnpj", values?.cnpj || "");
      erros = Validation.verificarForm(formData);
    } else {
      formData.append("uid", values?.uid || "");
      formData.append("razao_social", values?.razao_social || "");
      formData.append("cnpj", values?.cnpj || "");
      formData.append("email", values?.email || "");
      formData.append("cep", values?.cep || "");
      formData.append("logradouro", values?.logradouro || "");
      formData.append("numero", String(values?.numero) || "");
      formData.append("bairro", values?.bairro || "");
      formData.append("cidade", values?.cidade || "");
      formData.append("uf", values?.uf || "");
      formData.append("codigo_cidade", values?.codigo_cidade || "");
      erros = Validation.verificarForm(formData);
      formData.append("telefone", values?.telefone || "");
      formData.append("celular", values?.celular || "");
      formData.append("complemento", values?.complemento || "");
      if (values.cnpj.length > 11) {
        formData.append("nome_fantasia", values?.nome_fantasia || "");
        formData.append("inscr_municipal", values?.inscr_municipal || "");
      }
    }

    return { formData, erros };
  };

  const getDadosCnpj = async () => {
    try {
      const response = await getCnpjApi.request(values?.cnpj);

      if (!response) return;
      setValues({
        ...values,
        razao_social: response.nome,
        nome_fantasia: response.fantasia,
        email: response.email,
        telefone: response.telefone,
        logradouro: response.logradouro,
        numero: response.numero,
        complemento: response.complemento,
        bairro: response.bairro,
        cidade: response.municipio,
        uf: response.uf,
        cep: response.cep.replace(/[^0-9]/g, ""),
      });
      getCep(response.cep.replace(/[^0-9]/g, ""));
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  };

  return (
    <Card>
      <StepsList
        style={
          values?.cnpj
            ? values?.cnpj === "99999999999"
              ? { display: "none" }
              : null
            : { display: "none" }
        }
      >
        <StepsButton href="dados" ativo step={1}>
          Dados
        </StepsButton>
        <StepsButton href="endereco" step={2}>
          Endereço
        </StepsButton>
      </StepsList>
      <TabContent>
        <TabPane id="dados" ativo>
          {values?.cnpj ? (
            values?.cnpj === "99999999999" ? (
              <ClienteDadosEx valuesHook={{ values, setValues }} />
            ) : values?.cnpj.length === 11 ? (
              <ClienteDadosCPF valuesHook={{ values, setValues }} />
            ) : (
              <ClienteDadosCNPJ valuesHook={{ values, setValues }} />
            )
          ) : null}
        </TabPane>
        <TabPane id="endereco">
          {values?.cnpj === "99999999999" ? null : (
            <ClienteEndereco
              valuesHook={{ values, setValues }}
              cepApi={{ getCep, cepResponse }}
            />
          )}
        </TabPane>
      </TabContent>
      <ClienteButtons
        values={values}
        salvaCliente={salvaCliente}
        getDadosCnpj={getDadosCnpj}
      />
    </Card>
  );
}

export default Cliente;
